import React, { useState } from 'react'
import authorsteptwoStyle from './AuthormobilStepTwo.module.css'
import { FaEye, FaEyeSlash } from 'react-icons/fa';

export default function AuthormobilStepTwo() {

  // Password Eyes
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };

  // Confirm Password Eyes
  const [isCPasswordVisible, setCPasswordVisible] = useState(false);

  const toggleCPasswordVisibility = () => {
    setCPasswordVisible(!isCPasswordVisible);
  };

  return (
    <>
      <div className={authorsteptwoStyle.steppertwo}>
        <div className='row'>
          <div className='col-7'>
            <h3> Choose a Password </h3>
          </div>
          <div className='col-5'>
          </div>
        </div>
        <h5> Password Information </h5>
        <div className='row'>
          <div className='col-12'>
            <div className="mb-3">
              <div className={authorsteptwoStyle.twopasswordWrapper}>
                <input type={isPasswordVisible ? "text" : "password"} id="password-field" className={`${authorsteptwoStyle.twoInput} form-control`} placeholder='Choose your password' name="password" required />
                <div className={authorsteptwoStyle.twotoggleButton} onClick={togglePasswordVisibility}>
                  {isPasswordVisible ? <FaEyeSlash className={authorsteptwoStyle.twoIconeye} /> : <FaEye className={authorsteptwoStyle.threeIconeye} />}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <div className="mb-3">
              <div className={authorsteptwoStyle.twopasswordWrapper}>
                <input type={isCPasswordVisible ? "text" : "password"} id="password-field1" className={`${authorsteptwoStyle.twoInput} form-control`} placeholder='Confirm your password' name="confirmPassword" required />
                <div className={authorsteptwoStyle.twotoggleButton} onClick={toggleCPasswordVisibility}>
                  {isCPasswordVisible ? <FaEyeSlash className={authorsteptwoStyle.twoIconeye} /> : <FaEye className={authorsteptwoStyle.threeIconeye} />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}